module.exports = __webpack_public_path__ + "static/parker_marriot-0ee8e9c636603915630f030899a92ff7.jpg";